import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4bc78c2d"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "popup" }
const _hoisted_2 = { class: "popup-content" }
const _hoisted_3 = { class: "popup-text" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "popup-title" }, [
  /*#__PURE__*/_createElementVNode("img", {
    width: "100",
    height: "100",
    src: "/img/complain.svg"
  })
], -1))
const _hoisted_5 = { class: "popup-description" }
const _hoisted_6 = { class: "button-container" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_i18n_t = _resolveComponent("i18n-t")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("img", {
        src: "/img/close-btn.svg",
        class: "close-popup-btn",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_i18n_t, { keypath: "dashboard.declineAttentionPopup.description" })
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "button-text cancel-button",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closePopup && _ctx.closePopup(...args)))
          }, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.declineAttentionPopup.noButton" })
          ])
        ]),
        _createElementVNode("div", null, [
          _createElementVNode("button", {
            class: "button-text decline-button",
            onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.confirm && _ctx.confirm(...args)))
          }, [
            _createVNode(_component_i18n_t, { keypath: "dashboard.declineAttentionPopup.yesButton" })
          ])
        ])
      ])
    ])
  ]))
}